import styled from "styled-components";

export const Container = styled.div`
  margin: 29px auto 0;
  
  @media(min-width: 980px) {
    width: 1100px;
    margin-top: 60px;
  }
`

export const Slide = styled.div`
  position: relative;
  
    @media(min-width: 980px) {
        padding-left: 42px;
    }
`

export const Slider = styled.div`
  position: relative;

    @media(min-width: 980px) {
        padding-right: 100px;
    }
`

export const Next = styled.div`
    cursor: pointer;
    padding: 25px;
    top: 50%;
    transform: translateY(-100%);
    right: 0;
    position: absolute;
    display: none;
    
    @media(min-width: 980px) {
      display: block;
    }
`

export const Quote = styled.div`
  position: absolute;
  top: 32px;
  left: 32px;

    @media(min-width: 980px) {
        top: 0;
        left: 0;
    }
`

export const SlideInner = styled.div`
  padding: 72px 5px 32px 32px;
  background: #F7F7FA;
  border-radius: 10px;

    @media(min-width: 980px) {
        padding: 36px;
        min-height: 327px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
`

export const SlideText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 180%;
  color: #2A2637;
  margin-bottom: 12px;

    @media(min-width: 980px) {
        margin-bottom: 40px;
        font-size: 18px;
    }
`

export const SlideFooter = styled.div`


    @media(min-width: 980px) {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
`

export const Author = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #797199;
    margin-bottom: 12px;

    @media(min-width: 980px) {
        margin-bottom: 0;
    }
`

export const Date = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #A8A4B9;
`

export const Dot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #D1D0DA;
  cursor: pointer;
`

export const Dots = styled.div`
  margin-top: 36px;
  
  ul {
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  li {
    margin: 0 10px;
  }
  
  .slick-active {
    ${Dot} {
      background: #0D71D7;
    }
  }
    @media(min-width: 980px) {
        margin-top: 60px;
    }
`